import Icon, { ICON_NAMES } from "shared/components/utils/Icon";

import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import { LinkTabsLI, LinkTabsUL, TabList, Wrapper } from "./LinkTabs.styles";

const LinkTab = ({ label, leadingIcon, trailingIcon, iconColor, to }) => {
    return (
        <LinkTabsLI>
            {label && (
                <TabList to={to} exact="true">
                    {leadingIcon && <Icon name={leadingIcon} color={iconColor} />}
                    <Text variant="Headline_5">{label}</Text>
                    {trailingIcon && <Icon name={trailingIcon} color={iconColor} />}
                </TabList>
            )}
        </LinkTabsLI>
    );
};

const LinkTabs = ({ tabs, ...rest }) => {
    return (
        <Wrapper {...rest}>
            <LinkTabsUL>
                {tabs.map((data) => (
                    <LinkTab {...data} key={data.label} />
                ))}
            </LinkTabsUL>
        </Wrapper>
    );
};

LinkTab.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    leadingIcon: PropTypes.oneOf(ICON_NAMES),
    trailingIcon: PropTypes.oneOf(ICON_NAMES),
    iconColor: PropTypes.string,
    to: PropTypes.string,
};

LinkTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ]),
            leadingIcon: PropTypes.oneOf(ICON_NAMES),
            trailingIcon: PropTypes.oneOf(ICON_NAMES),
        })
    ),
};

export default LinkTabs;
